import { Card, CardContent, CardMedia, Typography } from '@mui/material';
import React from 'react';

/**
 * Box qui s'affichera si le tableau ne contient aucune information
 * @param props
 * @constructor
 */
export default function RequestCard(props: Readonly<{ text: string; data: number; img: string }>) {
    // retourne la box avec titre et message personnalisé
    return (
        // Déclararion de la card
        <Card className="relationRequestCard">
            {/*Ajout de l'image*/}
            <CardMedia className="relationRequestCard__media" component="img" src={props.img} alt="image service" />
            {/*Contenu du content*/}
            <CardContent className="relationRequestCard__content">
                {/* Texte envoyé */}
                <Typography className="relationRequestCard__title" variant="h6">
                    {props.text}
                </Typography>
                {/* Date actuelle */}
                <Typography className="relationRequestCard__meta" variant="body1">
                    Depuis : {new Date().getFullYear()}
                </Typography>
                {/* Data envoyée*/}
                <Typography className="relationRequestCard__value" variant="body1">
                    Nombre de demandes : {props.data}
                </Typography>
            </CardContent>
        </Card>
    );
}
